import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-ior-match-confirm-modal',
  templateUrl: './ior-match-confirm-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IorMatchConfirmModalComponent {
  @Input() public open: boolean = false;
  @Output() public accept: EventEmitter<void> = new EventEmitter<void>();
  @Output() public decline: EventEmitter<void> = new EventEmitter<void>();
}
